import { api } from '@/lib/api';

export async function downloadDocument(path, fallbackName='document.docx') {
  const response=await api.get(path,{responseType:'blob'});
  const match=/filename="([^"]+)"/.exec(response.headers['content-disposition'] || '');
  const url=window.URL.createObjectURL(response.data);
  const link=window.document.createElement('a');
  link.href=url;link.download=match?.[1] || fallbackName;
  window.document.body.appendChild(link);link.click();link.remove();
  window.setTimeout(()=>window.URL.revokeObjectURL(url),30000);
}
